// iot-admin/client/src/auth/authClient.js
//
// Thin adapter over the shared @galigali/auth-client package.
//
// This file used to be a DIVERGENT FORK of the browser auth client that had
// drifted from the canonical implementation and lacked the cross-domain SSO fix
// (independent refresh-token families). It now delegates to the shared package
// so iot-admin inherits that fix (and every future one) automatically.
//
// Packaging note: iot-admin/client is Create React App, whose Webpack cannot
// transpile the shared package's TypeScript from node_modules. So
// scripts/stage-local-packages.sh bundles the shared source to a plain-JS
// module vendored at src/vendor/auth-client (canonical source stays
// packages/auth-client). Origin is pinned to 'iot-admin' so existing call sites
// keep working without passing it.
//
// NOTE: init() is async in the shared client (it awaits the silent refresh
// before resolving). iot-admin's only init() caller (src/index.js) ignores the
// return value, so no call-site change is needed.

import { authClient as shared } from '../vendor/auth-client/index.js';

const ORIGIN = 'iot-admin';

export const authClient = {
  init: (opts = {}) => shared.init({ origin: ORIGIN, ...opts }),
  getAccessToken: () => shared.getAccessToken(),
  getValidAccessToken: () => shared.getValidAccessToken(),
  getUser: () => shared.getUser(),
  getTenants: () => shared.getTenants(),
  getActiveTenantId: () => shared.getActiveTenantId(),
  setActiveTenantId: (tenantId) => shared.setActiveTenantId(tenantId),
  isAuthenticated: () => shared.isAuthenticated(),
  logout: (opts) => shared.logout(opts),
  handle401: () => shared.handle401(),
  onAuthChange: (listener) => shared.onAuthChange(listener),
};

export default authClient;
